import {
  ContentWrapper,
  PageWrapper,
} from "../../../../../../features/layout/components/layout.styles";
import { FlyerDetailHeader } from "../flyer-detail-header/flyer-detail-header.component";
import { BriefErrorMessage } from "../../../../../../components/brief/BriefErrorMessage";
import React, { useRef, useState } from "react";
import { HEADER_MIN_HEIGHT } from "../../../../../../utils/constants";
import { IFormRef } from "../../../../../../features/forms/types/forms.interface";
import { createFormRef } from "../../../../../../features/forms/types/forms.functions";
import { FlyerDetailViewProps } from "./flyer-detail-view.props";
import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";
import { FlyerDetailViewTabs } from "../flyer-detail-view-tabs/flyer-detail-view-tabs.component";
import { SpinnerLoader } from "../../../../../../components/loaders";

export const FlyerDetailView = withShowIf((props: FlyerDetailViewProps) => {
  const [headerHeight, setHeaderHeight] = useState(HEADER_MIN_HEIGHT);
  const [currentTabValue, setCurrentTabValue] = useState<number>(0);
  const [forceOpen, setForceOpen] = useState<false | (() => any)>(false);
  const formRef = useRef<Partial<IFormRef>>(createFormRef());

  const shouldChangeTab = (newTabValue: number, changeTab: () => void) => {
    if (formRef.current.isDirty && currentTabValue === 0) {
      setForceOpen(() => (response: boolean) => {
        setForceOpen(false);

        if (response) {
          changeTab();
        }
      });

      return false;
    }

    return true;
  };

  const handleTabChange = (newValue: number) => {
    setCurrentTabValue(newValue);
  };

  const hasErrors = () => Boolean(props.errors);
  const shouldShowTabsContent = () =>
    !hasErrors() && Boolean(props.flyer) && Boolean(props.permissions);

  return (
    <PageWrapper>
      <FlyerDetailHeader
        currentTabValue={currentTabValue}
        flyer={props.flyer}
        formRef={formRef}
        hasErrors={hasErrors()}
        loaded={props.isLoaded}
        setHeaderHeight={setHeaderHeight}
        permissions={props.permissions}
        onChangeName={props.onChangeName}
        onSubmit={props.onSave}
      />
      <ContentWrapper>
        <BriefErrorMessage showIf={hasErrors()} errors={props.errors!} />
        <SpinnerLoader showIf={props.isLoading} hasBackdrop={true} />
        <FlyerDetailViewTabs
          showIf={shouldShowTabsContent()}
          isLoading={props.isLoading}
          permissions={props.permissions}
          formErrors={props.formErrors}
          flyer={props.flyer}
          errors={props.errors}
          isPageExportModalOpen={props.isPageExportModalOpen}
          headerHeight={headerHeight}
          formRef={formRef}
          forceOpen={forceOpen}
          currentTabValue={currentTabValue}
          isLoaded={props.isLoaded}
          shouldChangeTab={shouldChangeTab}
          onTabChange={handleTabChange}
          onAddPage={props.onAddPage}
          onDeletePage={props.onDeletePage}
          onClickPage={props.onClickPage}
        />
      </ContentWrapper>
    </PageWrapper>
  );
});
